const _ = require('lodash');
const moment = require('moment');
const PasswordValidator = require('password-validator');
const { parsePhoneNumberFromString } = require('libphonenumber-js');

const passwordSchema = new PasswordValidator();

/**
 * Check email
 */
const checkEmail = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('Email is required'));
  }
  const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  if (re.test(String(value).toLowerCase())) return callback();
  return callback(new Error('Invalid email address'));
};

/**
 * Check password
 */
const checkPassword = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('Password is required'));
  }
  if (+process.env.VUE_APP_NATIONAL_ID === 19 || (+process.env.VUE_APP_NATIONAL_ID === 1 && process.env.VUE_APP_PIN_ENV === 'test')) {
    passwordSchema
      .is().min(8) // Minimum length 8
      .has().lowercase() // Must have lowercase letters
      .has()
      .symbols() // Must have symbols
      .has()
      .not()
      .spaces(); // Should not have spaces
    if (passwordSchema.validate(value)) return callback();
    return callback(new Error('Password must be at least 8 characters and special characters.'));
  }
  passwordSchema
    .is().min(8)
    .has().uppercase()
    .has()
    .lowercase()
    .has()
    .symbols()
    .has()
    .not()
    .spaces();
  if (passwordSchema.validate(value)) return callback();
  return callback(new Error('Password must be at least 8 characters with uppercase, lowercase and special characters.'));
};

/**
 * Check mobile
 * put last param default country code to AU
 */
const checkMobile = (rule, value, callback, countryCode = 'AU') => {
  if (!value) {
    return callback(new Error('Mobile is required'));
  }
  // eslint-disable-next-line no-param-reassign
  value = value.replace(/\s/g, '');
  console.log('value', value);
  console.log('countryCode', countryCode);
  const phoneNumber = parsePhoneNumberFromString(value, countryCode);
  console.log('phoneNumber', phoneNumber);
  const test = !!(((phoneNumber && phoneNumber.isValid())));
  if (test) return callback();
  return callback(new Error('Invalid mobile'));
};

/**
 * Check birthdate
 */
const checkBirthdate = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('Birthdate is required'));
  }
  const re = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
  if (re.test(String(value).toLowerCase())) return callback();
  return callback(new Error('Invalid birth date'));
};

/**
 * Parse birthdate DD/MM/YYYY -> YYYY-MM-DD
 * @param {string} val: birthdate
 */
const parseBirthdate = (val, reverse = false) => {
  if (reverse) return moment(val, 'YYYY-MM-DD').format('DD/MM/YYYY');
  return moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
};

/**
 * Validate if value is a valid name
 * @param {any} value: value for validation
 */
const checkName = (rule, value, callback) => {
  if ((value && !_.isString(value)) || (value && !/^[a-zA-Z-.' ]*$/.test(value))) return callback(new Error('Invalid Name'));
  return callback();
};

/**
 * Validate if value is a Number
 * @param {any} value: value for validation
 */
const checkNumber = (rule, value, callback) => {
  if (value && !/^[0-9  ]*$/.test(value)) return callback(new Error('Invalid Number'));
  return callback();
};

module.exports = {
  checkEmail,
  checkPassword,
  checkMobile,
  checkBirthdate,
  checkName,
  parseBirthdate,
  checkNumber
};
